import ContentPasteOutlined from "@mui/icons-material/ContentPasteOutlined";
import PersonOutlined from "@mui/icons-material/PersonOutlined";
import PersonAdd from "@mui/icons-material/PersonAdd";
import AssessmentOutlined from "@mui/icons-material/AssessmentOutlined";
import HelpOutlineOutlined from "@mui/icons-material/HelpOutlineOutlined";
import AssignmentTurnedIn from "@mui/icons-material/AssignmentTurnedIn";
import CreditCard from "@mui/icons-material/CreditCard";
import HubOutlined from "@mui/icons-material/HubOutlined";
import ArticleOutlined from "@mui/icons-material/ArticleOutlined";
import GroupOutlined from "@mui/icons-material/GroupOutlined";
import DomainOutlined from "@mui/icons-material/DomainOutlined";
import NoteAltOutlined from "@mui/icons-material/NoteAltOutlined";

/**
 * The icon names the left navigation can actually render.
 *
 * SIMS-8687 AC4 needs a picker, and a picker needs a vocabulary. This is it — `getIcon` returns
 * null for anything else, so an action carrying a name outside this list shows NO icon in the
 * navigation at all. Exported from the resolver rather than retyped next to the picker,
 * precisely so the two cannot drift: adding a case below without adding it here would leave an
 * icon that renders but cannot be chosen, and the reverse would offer one that silently vanishes.
 *
 * OQ-5 IS OPEN. The Hi-Fi (actions-12-action-editor-nav-order-icon) draws roughly fourteen
 * glyphs, and they do not map one to one onto these twelve — the owners (Qori + the dev team)
 * have yet to confirm the vocabulary. This list is the one that WORKS today, which is why the
 * picker is built from it rather than from the export: an icon copied off the mock that has no
 * case below would be saved and then not appear.
 */
export const NAV_ICON_NAMES = [
	"content-paste-outlined",
	"person-outlined",
	"assessment-outlined",
	"help-outline-outlined",
	"assignment-turned-in",
	"credit-card",
	"person-add",
	"hub-outlined",
	"programs-config",
	"group-outlined",
	"domain-outlined",
	"note-outlined",
] as const;

export type NavIconName = (typeof NAV_ICON_NAMES)[number];

const getIcon = (iconName: string) => {
	switch (iconName) {
		case "content-paste-outlined":
			return <ContentPasteOutlined />;
		case "person-outlined":
			return <PersonOutlined />;
		case "assessment-outlined":
			return <AssessmentOutlined />;
		case "help-outline-outlined":
			return <HelpOutlineOutlined />;
		case "assignment-turned-in":
			return <AssignmentTurnedIn />;
		case "credit-card":
			return <CreditCard />;
		case "person-add":
			return <PersonAdd />;
		case "hub-outlined":
			return <HubOutlined />;
		case "programs-config":
			return <ArticleOutlined />;
		case "group-outlined":
			return <GroupOutlined />;
		case "domain-outlined":
			return <DomainOutlined />;
		case "note-outlined":
			return <NoteAltOutlined />;
		default:
			return null;
	}
};

export default getIcon;
